import * as types from "./types";

export const setProfanityWord = (data) => ({
    type: types.SET_PROFANITY_WORDS,
    payload: data
});